import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedEvents from './components/FeaturedEvents';
import CategoryCards from './components/CategoryCards';
import LatestNews from './components/LatestNews';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main>
        <HeroSection />
        <FeaturedEvents />
        <CategoryCards />
        <LatestNews />
        <CTASection />
      </main>

      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'BB体育',
            url: 'https://www.bbtiyu.com/',
            description: 'BB体育是专业体育赛事服务平台，涵盖足球、篮球、网球、电竞等多项热门赛事，提供实时数据、精彩赛事直播与深度体育资讯。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://www.bbtiyu.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: 'BB体育官方平台·专业体育赛事服务',
            description: 'BB体育是您首选的专业体育服务平台，涵盖多项热门赛事、实时数据、精彩赛事直播与深度体育资讯。注册即享专属福利。',
            url: 'https://www.bbtiyu.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: 'BB体育',
              url: 'https://www.bbtiyu.com/',
            },
          }),
        }}
      />
    </>
  );
}